import React, { useState } from 'react';

// components
import Devices from '../../modules/Profile/Security/Devices';
import Sessions from '../../modules/Profile/Security/Sessions';
import ChangePassword from '../../modules/Profile/Security/ChangePassword';
import SessionSettings from '../../modules/Profile/Security/SessionSettings';
import UpdatePrimaryEmail from 'modules/Profile/Security/UpdatePrimaryEmail';
import IdentityVerification from '../../modules/Profile/Security/IdentityVerification';
import TwoFactorAuthentication from '../../modules/Profile/Security/TwoFactorAuthentication';
import UpdatePrimaryPhoneNumber from 'modules/Profile/Security/UpdatePrimaryPhoneNumber';

const Security = () => {
  const [updateViewTrigger, setUpdateViewTrigger] = useState({});

  const updateView = () => {
    setUpdateViewTrigger({});
  };

  return (
    <>
      <TwoFactorAuthentication />

      <IdentityVerification />

      <UpdatePrimaryEmail />

      <UpdatePrimaryPhoneNumber />

      <ChangePassword />

      <Devices updateViewTrigger={updateViewTrigger} updateView={updateView} />

      <Sessions updateViewTrigger={updateViewTrigger} updateView={updateView} />

      <SessionSettings />
    </>
  );
};

export default Security;
